const m = require('minthril');
const { component } = require('../../component');
const {
  completeMcpOAuthConsent,
  denyMcpOAuthConsent,
  loadMcpOAuthRequest
} = require('../../controllers/mcp');

const scopeDescriptions = {
  'sites:read': 'View your Spache sites, origins, and preview links',
  'sites:write': 'Add an already-deployed site to your Spache account',
  'webhooks:write': 'Create or rotate a cache-invalidation webhook for a site'
};

const OAuthAuthorizePage = component((vnode, emit) => {
  let checkedRequestId = null;
  let loading = false;
  let submitting = false;
  let details = null;
  let error = null;

  async function load (requestId) {
    checkedRequestId = requestId;
    loading = true;
    error = null;
    try {
      details = await loadMcpOAuthRequest(requestId);
    } catch (reason) {
      error = reason.message;
    } finally {
      loading = false;
      emit('redraw');
    }
  }

  async function finish (requestId, user, approved) {
    submitting = true;
    error = null;
    try {
      const result = approved
        ? await completeMcpOAuthConsent(user, requestId, true)
        : await denyMcpOAuthConsent(requestId);
      window.location.assign(result.redirectUrl);
    } catch (reason) {
      error = reason.message;
      submitting = false;
      emit('redraw');
    }
  }

  return {
    view: ({ attrs: { user, onSignIn } }) => {
      const requestId = new URLSearchParams(window.location.search).get('request');
      if (requestId && checkedRequestId !== requestId && !loading) load(requestId);

      return m('section.panel.oauth-authorize', [
        m('h2', 'Connect Spache to your coding agent'),
        loading && m('p.muted', 'Checking the authorization request…'),
        error && m('p.error', error),
        !loading && details && [
          m('p', `${details.clientName} is requesting access to your Spache account.`),
          m('ul.oauth-authorize__permissions', details.scopes.map(scope =>
            m('li', scopeDescriptions[scope] || scope))),
          user
            ? m('p.muted', `Signed in as ${user.email || 'your Spache account'}.`)
            : m('div.oauth-authorize__signin', [
              m('p.muted', 'Sign in to review and approve this connection.'),
              m('button.button', { type: 'button', onclick: onSignIn }, 'Continue with Google')
            ]),
          m('div.oauth-authorize__actions', [
            m('button.button.button--quiet', {
              type: 'button',
              disabled: submitting,
              onclick: () => finish(requestId, user, false)
            }, 'Cancel'),
            user && m('button.button', {
              type: 'button',
              disabled: submitting,
              onclick: () => finish(requestId, user, true)
            }, submitting ? 'Connecting…' : 'Allow access')
          ])
        ],
        !requestId && m('p.error', 'This authorization link is incomplete. Start the connection again from your MCP client.')
      ]);
    }
  };
});

module.exports = { OAuthAuthorizePage };
